/**
 * Web3Forms contact form – submit via fetch, show feedback
 */
export default function contactForm() {
    const form = document.getElementById('form');
    if (!form) return;

    const submitBtn = form.querySelector('button[type="submit"]');
    if (!submitBtn) return;

    form.addEventListener('submit', async (e) => {
        e.preventDefault();

        const formData = new FormData(form);

        const originalText = submitBtn.textContent;

        submitBtn.textContent = 'Sending...';
        submitBtn.disabled = true;

        try {
            const response = await fetch('https://api.web3forms.com/submit', {
                method: 'POST',
                body: formData
            });

            const data = await response.json();

            if (response.ok) {
                form.reset();
                const formBlock = form.closest('.gh-contact-form-block');
                const successEl = document.getElementById('contact-success');
                if (formBlock && successEl) {
                    formBlock.hidden = true;
                    successEl.hidden = false;
                } else {
                    alert('Success! Your message has been sent.');
                }
            } else {
                alert('Error: ' + (data.message || 'Something went wrong.'));
            }
        } catch (error) {
            alert('Something went wrong. Please try again.');
        } finally {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
        }
    });
}
